import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FireIcon } from '~/assets/icons';
import { CloseIcon } from '~/assets/icons';

interface FireAlarmAlertProps {
  data?: any;
  closeToast?: any;
}

const FireAlarmAlert = ({ data, closeToast }: FireAlarmAlertProps) => {
  const { t } = useTranslation(['admin/component']);
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/admin/alerts', {
      state: { alertId: data?.id },
    });
    closeToast();
  };

  const getSensorTypeLabel = (type: number) => {
    switch (type) {
      case 17:
        return 'Khói';
      case 18:
        return 'Nhiệt';
      case 19:
        return 'Tủ thiết bị';
      case 21:
        return 'Nút nhấn khẩn cấp';
    }
  };
  return (
    <Box className='flex flex-col gap-3 ' onClick={handleOnClick}>
      <Box className='flex items-center justify-center gap-2'>
        <FireIcon className='w-[28px] h-[28px]' />
        <Typography className=' font-extrabold text-[20px] leading-[100%] tracking-[0] text-white'>
          Cảnh báo cháy
        </Typography>
      </Box>

      <CloseIcon
        className='absolute w-4 h-4 top-1 right-1 hover:cursor-pointer'
        onClick={(e) => {
          e.stopPropagation();
          closeToast();
        }}
      />

      <Box className='grid grid-cols-2 gap-y-2 ps-[30px]'>
        <Box className='flex items-center gap-[6px]'>
          <Typography className='font-bold text-[13px] leading-[100%] text-white'>
            {t('fireAlarmToast.locationName')}:
          </Typography>
          <Typography className='font-normal text-[13px] leading-[100%] text-white'>{data?.location_name}</Typography>
        </Box>

        <Box className='flex items-center gap-[6px]'>
          <Typography className='font-bold text-[13px] leading-[100%] text-white'>
            {t('fireAlarmToast.positionAlert')}:
          </Typography>
          <Typography className='font-normal text-[13px] leading-[100%] text-white'>{data?.sensor_location}</Typography>
        </Box>

        <Box className='flex items-center gap-[6px]'>
          <Typography className='font-bold text-[13px] leading-[100%] text-white'>
            {t('fireAlarmToast.locationAddress')}:
          </Typography>
          <Typography className='font-normal text-[13px] leading-[100%] text-white'>
            {data?.location_address}
          </Typography>
        </Box>

        <Box className='flex items-center gap-[6px]'>
          <Typography className='font-bold text-[13px] leading-[100%] text-white'>
            {t('fireAlarmToast.typeSensor')}:
          </Typography>
          <Typography className='font-normal text-[13px] leading-[100%] text-white'>
            {getSensorTypeLabel(data?.sensor_type)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FireAlarmAlert;
